"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolbarGoToComponent = void 0;
const React = __importStar(require("react"));
const antd_1 = require("antd");
const useBreakpoint_1 = __importDefault(require("antd/es/grid/hooks/useBreakpoint"));
const AppRouter_1 = require("src/configeek_assets/src/components/common/AppRouter");
const react_router_dom_1 = require("react-router-dom");
const CurrentPageProvider_1 = require("src/configeek_assets/src/components/common/provider/CurrentPageProvider");
const PageRedirectComponent_1 = require("src/configeek_assets/src/components/common/PageRedirectComponent");
const ProjectsDataProvider_1 = require("src/configeek_assets/src/components/common/provider/ProjectsDataProvider");
const ToolbarGoToComponent = () => {
    const breakpoint = (0, useBreakpoint_1.default)();
    const projectsDataContext = (0, ProjectsDataProvider_1.useProjectsDataContext)();
    const { page } = (0, CurrentPageProvider_1.useCurrentPageContext)();
    const lastCreatedProject = projectsDataContext.getLastCreatedProject();
    const storedLastProjectApiKey = PageRedirectComponent_1.LastProjectStorage.getProjectApiKey();
    let projectApiKey;
    if (page.identifier === "project") {
        projectApiKey = page.projectApiKey;
    }
    else if (storedLastProjectApiKey) {
        projectApiKey = storedLastProjectApiKey;
    }
    else if (lastCreatedProject) {
        projectApiKey = lastCreatedProject.view.project.projectApiKey;
    }
    if (projectApiKey) {
        const size = breakpoint.md ? "large" : "middle";
        return React.createElement(antd_1.Space, { direction: "horizontal", size: size, className: "toolbarGoToLinks" },
            React.createElement(react_router_dom_1.Link, { to: AppRouter_1.PathGenerator.project(projectApiKey, "parameters") }, "Configuration"),
            React.createElement(react_router_dom_1.Link, { to: AppRouter_1.PathGenerator.project(projectApiKey, "auditLog") }, "Audit"),
            React.createElement(react_router_dom_1.Link, { to: AppRouter_1.PathGenerator.project(projectApiKey, "settings") }, "Settings"));
    }
    return null;
};
exports.ToolbarGoToComponent = ToolbarGoToComponent;
